// src/screens/RestoreAccountScreen.js
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

export default function RestoreAccountScreen({ navigation }) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Account Disabled</Text>
      <Text style={styles.message}>
        This account has been disabled and is pending deletion.
      </Text>
      <Text style={styles.message}>
        If you believe this to be a mistake or would want to restore your account, please contact our team at support@critcash.com for assistance.
      </Text>
      
      <TouchableOpacity style={styles.loginButton} onPress={() => navigation.replace('Login')}>
        <Text style={styles.buttonText}>Return to Login</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#000', justifyContent: 'center', alignItems: 'center', padding: 20 },
  title: { fontSize: 24, fontWeight: 'bold', color: '#E74C3C', marginBottom: 20, textAlign: 'center' },
  message: { color: '#ccc', textAlign: 'center', marginBottom: 20, fontSize: 16, lineHeight: 24 },
  loginButton: { backgroundColor: '#FCD000', width: '100%', padding: 15, borderRadius: 8, alignItems: 'center', marginTop: 20 },
  buttonText: { color: '#000', fontSize: 16, fontWeight: 'bold' },
});